import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';

export const ImpressumPage = () => {
  return (
    <>
      <Helmet>
        <title>Impressum | M.A. Zulassungsdienst Velbert</title>
        <meta name="description" content="Impressum und rechtliche Angaben von M.A. Zulassungsdienst - Mazlum Aksu, Velbert" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="min-h-screen overflow-x-hidden">
        <Header />
        <main className="pt-32 pb-20 px-4 sm:px-10 md:px-20 bg-white">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold mb-8 text-[#0D0D0D]">Impressum</h1>
            
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">Angaben gemäß § 5 DDG</h2>
              
              <p className="mb-4">
                <strong>M.A. Zulassungsdienst</strong><br/>
                Inhaber: Mazlum Aksu<br/>
                Einzelunternehmen
              </p>

              <p className="mb-4">
                <strong>Anschrift:</strong><br/>
                Kamperstraße 8<br/>
                42555 Velbert<br/>
                Deutschland
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">Kontakt</h2>
              <p className="mb-4">
                <strong>Telefon:</strong> <a href="tel:015159182828" className="text-[#006B3F] hover:underline">0151 59182828</a><br/>
                <strong>E-Mail:</strong> <a href="mailto:kontakt@mazulassungsdienst.de" className="text-[#006B3F] hover:underline">kontakt@mazulassungsdienst.de</a><br/>
                <strong>Website:</strong> <a href="https://mazulassungsdienst.de" className="text-[#006B3F] hover:underline">https://mazulassungsdienst.de</a>
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">Geschäftstätigkeit</h2>
              <p className="mb-4">
                M.A. Zulassungsdienst bietet Dienstleistungen rund um Fahrzeugzulassungen, Ummeldungen und Abmeldungen an.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">Hinweise zur Versicherungs- und Finanzanlagenvermittlung</h2>
              <p className="mb-4">
                Über diese Website können Anfragen zu eVB-Nummern, Kfz-Versicherungen und Finanzanlagen gestellt werden. 
                Die Versicherungs- und Finanzanlagenvermittlung erfolgt über die <strong>HDI Hauptvertretung Mazlum Aksu</strong>, 
                die rechtlich eigenständig von M.A. Zulassungsdienst ist.
              </p>

              <div className="bg-gray-50 p-6 rounded-lg my-6">
                <h3 className="text-xl font-bold mb-4 text-[#0D0D0D]">HDI Hauptvertretung Mazlum Aksu</h3>
                <p className="mb-3">
                  <strong>Mazlum Aksu</strong><br/>
                  Versicherungs- und Finanzkaufmann (IHK)<br/>
                  Finanzanlagenfachmann (IHK)<br/>
                  Agenturleiter
                </p>
                <p className="mb-3">
                  <strong>Anschrift:</strong><br/>
                  HDI Hauptvertretung Mazlum Aksu<br/>
                  Kamper Str. 8<br/>
                  42555 Velbert
                </p>
                <p className="mb-3">
                  <strong>Kontakt:</strong><br/>
                  Telefon: <a href="tel:020528352655" className="text-[#006B3F] hover:underline">02052 8352655</a><br/>
                  Mobil: <a href="tel:015565705727" className="text-[#006B3F] hover:underline">0155 65705727</a><br/>
                  E-Mail: <a href="mailto:mazlum.aksu@hdi.de" className="text-[#006B3F] hover:underline">mazlum.aksu@hdi.de</a><br/>
                  Website: <a href="https://www.hdi.de/betreuer/mazlum-aksu/" target="_blank" rel="noopener noreferrer" className="text-[#006B3F] hover:underline">www.hdi.de/betreuer/mazlum-aksu/</a>
                </p>
                <p className="mb-3">
                  <strong>Versicherungsvermittlung:</strong><br/>
                  Gebundener Versicherungsvertreter nach § 34d Abs. 7 GewO<br/>
                  Eingetragen in das Vermittlerregister nach § 34d Abs. 10 Satz 1 GewO<br/>
                  Vermittlerregister: <strong>D-G9R0-U54P-W-49</strong>
                </p>
                <p className="mb-3">
                  <strong>Finanzanlagenvermittlung:</strong><br/>
                  Finanzanlagenvermittler mit Erlaubnis nach § 34f Abs. 1 Satz 1 Nr. 1 GewO<br/>
                  Vermittlerregister: <strong>D-G9R0-U54P-W-49</strong>
                </p>
                <p className="mb-3">
                  <strong>Zuständige Erlaubnis- und Registerbehörde:</strong><br/>
                  Industrie- und Handelskammer zu Düsseldorf<br/>
                  Ernst-Schneider-Platz 1<br/>
                  40212 Düsseldorf
                </p>
                <p className="mb-3">
                  <strong>Gemeinsame Stelle i.S.d. § 11a Abs. 1 GewO:</strong><br/>
                  Deutscher Industrie- und Handelskammertag (DIHK) e.V.<br/>
                  Breite Str. 29<br/>
                  10178 Berlin<br/>
                  <a href="https://www.vermittlerregister.info" target="_blank" rel="noopener noreferrer" className="text-[#006B3F] hover:underline">www.vermittlerregister.info</a>
                </p>
                <p className="text-sm mt-4">
                  Vertreten werden im Bereich der Versicherungsvermittlung ausschließlich die HDI Versicherung AG, 
                  HDI Global SE, HDI Global Specialty SE, HDI Lebensversicherung AG, HDI Pensionsfonds AG, 
                  HDI Pensionskasse AG sowie die Kooperationspartner ROLAND Rechtsschutz-Versicherungs-AG, 
                  ROLAND Schutzbrief-Versicherung AG, Atradius Kreditversicherung, DKV Deutsche Krankenversicherung AG 
                  und IDEAL Lebensversicherung a.G.
                </p>
              </div>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">Schlichtungsstellen</h2>
              <p className="mb-4">
                <strong>Versicherungen:</strong><br/>
                Versicherungsombudsmann e.V.<br/>
                Kronenstraße 13, 10117 Berlin<br/>
                <a href="https://www.versicherungsombudsmann.de" target="_blank" rel="noopener noreferrer" className="text-[#006B3F] hover:underline">www.versicherungsombudsmann.de</a>
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">Haftungsausschluss</h2>
              
              <h3 className="text-xl font-semibold mt-6 mb-3 text-[#0D0D0D]">Haftung für Inhalte</h3>
              <p className="mb-4">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit 
                und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß 
                § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. 
                Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder 
                gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
                rechtswidrige Tätigkeit hinweisen.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3 text-[#0D0D0D]">Haftung für Links</h3>
              <p className="mb-4">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
                Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3 text-[#0D0D0D]">Urheberrecht</h3>
              <p className="mb-4">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
                Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
                Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};